import Cookies from 'js-cookie';

export const cookieOptions = {
  path: '/',
  domain: window.location.hostname.includes('localhost') ? undefined : `.${window.location.hostname.split('.').slice(-2).join('.')}`,
  expires: 365,
};

export function saveClaims(claims: Record<string, string>) {
  Object.keys(claims).forEach(key => {
    Cookies.set(key, claims[key], cookieOptions);
  });
}

export function saveUserName(user: { email: string; save: boolean }) {
  Cookies.set('save', String(user.save), cookieOptions);
  if (user.save) {
    Cookies.set('username', user.email, cookieOptions);
  } else {
    Cookies.remove('username', cookieOptions);
  }
}

/**
 * Store all query string parameters in cookies (same path/domain/expires as claims).
 * Call when SignIn/SignUp load with a query string so params persist across redirects (e.g. Google login).
 */
export function saveQueryParamsToCookies(search: string) {
  if (!search || search.charAt(0) !== '?') return;
  const params = new URLSearchParams(search);
  params.forEach((value, key) => {
    try {
      Cookies.set(key, decodeURIComponent(value), cookieOptions);
    } catch {
      Cookies.set(key, value, cookieOptions);
    }
  });
} 